import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type IUserState = {
  isAuthorized: boolean;
  isCianAuthorized: boolean;
};

const initialState: IUserState = {
  isAuthorized: false,
  isCianAuthorized: false,
};

/* istanbul ignore next */
export const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    setIsCianAuthorized: (state, action: PayloadAction<boolean>) => {
      state.isCianAuthorized = action.payload;
    },
  },
});

export const { setIsCianAuthorized } = userSlice.actions;
